//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-business",
  props:['defaultPar','sourceDto']
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-business.vue